import axios from 'axios';

import authHeader from './auth-header'

class NotificationService {
  getUnread() {
    const auth_header = authHeader();

    return axios.get(import.meta.env.VITE_APP_API_URL + '/notification/unread', {headers: auth_header});
  }

  getAll() {
    const auth_header = authHeader();

    return axios.get(import.meta.env.VITE_APP_API_URL + '/notification/all', { headers: auth_header });
  }

  markAsRead (id:any) {
    const auth_header = authHeader();

    return axios.post(import.meta.env.VITE_APP_API_URL + '/notification/mark-as-read', { id: id }, {headers: auth_header});
  }

  
  get(id:any) {
    const auth_header = authHeader();

    return axios.get(import.meta.env.VITE_APP_API_URL + '/notification/' + id, {headers: auth_header});
  }

  create(item:any) {
    const auth_header = authHeader();

    let body = Object.assign({}, item);

    delete body['_id'];

    return axios.post(import.meta.env.VITE_APP_API_URL + '/notification', body, {headers: auth_header})
  }

  update(item:any) {
    const auth_header = authHeader();

    let body = Object.assign({}, item);

    delete body['_id'];

    return axios.patch(import.meta.env.VITE_APP_API_URL + '/notification/'+item._id, body, {headers: auth_header});
  }

  delete(id:any) {
    const auth_header = authHeader();

    return axios.delete(import.meta.env.VITE_APP_API_URL + '/notification/'+id, {headers: auth_header});
  }
}
export default new NotificationService();
